<template>
  <div>
    <section id="thankYouPage" class="is-medium">
      <div class="columns is-gapless is-centered">
        <div class="column hero is-fullheight">
          <div class="hero-body">
            <article class="is-rounded">
              <h1 class="title has-text-centered">
                <img src="/static/img/logo/hp-logo.svg" alt="logo" width="300">
              </h1>
              <p class="has-text-centered has-text-weight-bold is-size-3">Thanks for your feedback</p>
              <p class="has-text-centered is-size-6">You're helping our business do better!</p>
              <p class="has-text-centered"><a :href="consumerFrontendUrl" class="button is-button-blue is-size-5">WRITE ANOTHER REVIEW</a></p>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  export default {
    name: 'NpsThankYou',
    metaInfo: {
      title: 'Business Portal | Hellopeter - NPS Thank You'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'NPS Thank You'
      })
    },
    data () {
      return {
        consumerFrontendUrl: process.env.HP_APP_URL + '/write-a-review'
      }
    }
  }
</script>
<style scoped>
  #thankYouPage article {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: none;
  }

  .column-with-bg p {
    margin-left: auto;
    margin-right: auto;
    color: #ffffff;
    opacity: 0.5;
    padding-left: 6rem;
    padding-right: 6rem;
    line-height: 6rem;
  }

  #thankYouPage input {
    border-radius: 0!important;
    border: 1px solid #dbdbdb!important;
    box-shadow: none!important;
    height: 3em;
  }

  #thankYouPage .button {
    border: 0;
    border-radius: 0;
    height: 3em;
    margin-top: 30px;
  }

  #thankYouPage p.control:last-child {
    margin-top: 50px;
  }

  #thankYouPage a.VuePassword__Toggle {
    color: gray!important;
  }

  @media screen and (max-width: 768px) {
    #thankYouPage .column:not(:first-child) p {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/nps/NPSThankYou.vue